package org.multiplatform.kotfolio.pages.kobweb

import androidx.compose.runtime.Composable
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.core.Page

@Page("kobweb_basic")
@Composable
fun KobWebBasicPage() {
    BlogLayout(
        PageProperties(
            "Kobweb",
            ""
        ),
        BlogProperties("Kobweb", "Basic")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            //https://opletter.github.io/css2kobweb/

            KotlinCode(
                code = """
                     1. kobweb run
                     2. ./gradlew kobwebStart
                     3. kobweb export --layout static
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //Module implement 
                    jsMain.dependencies {
                        implementation(project(":moduleName"))
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //Condition modifier if else
                    
                    @Composable
                    fun RatingBar(modifier: Modifier = Modifier) {
                        Row(modifier = modifier) {
                            repeat(5) {
                                Image(
                                    modifier = Modifier
                                        .margin(right = if (it != 4) 2.px else 0.px)
                                        .size(16.px),
                                    src = Res.Icon.star,
                                    description = "Star Icon"
                                )
                            }
                        }
                    }
                """.trimIndent()
            )

            KotlinCode(
                //1 Style
                code = """
                        A(href = url, attrs = {
                            style {
                                property("display", "flex")
                                property("align-items", "center")
                                property("gap", "8px")
                                property("text-decoration", "none")
                                property("padding", "8px 12px")
                                property("border-radius", "8px")
                                property("background", "white")
                                property("color", "black")
                                property("box-shadow", "0px 2px 5px rgba(0, 0, 0, 0.2)")
                                property("transition", "transform 0.2s")
                                property("&:hover", "transform: scale(1.1)")
                            }
                        }) { }
                        
                        //2 Style
                        object Style : StyleSheet() {
                            init {
                                universal style {
                                    margin(0.px)
                                    padding(0.px)
                                    boxSizing("border-box")
                                }

                                "body" style {
                                    backgroundColor(Color("#f5f5f5"))
                                    fontFamily("Roboto", "sans-serif")
                                }
                            }
                        }

                        @App
                        @Composable
                        fun AppEntry(content: @Composable () -> Unit) {
                            SilkApp {
                                Style(Style)
                                content()
                            }
                        }
                        
                        //3 Style
                        val CircleButtonVariant = ButtonStyle.addVariantBase {
                            Modifier.padding(0.px).borderRadius(50.percent)
                        }
                        
                        //4
                        fun Modifier.AttrClasses(classString: String): AttrsScope<*>.() -> Unit = {
                            classes(*classString.split(Regex("\\s+")).toTypedArray())
                        }

                        // New overload: allow calling with a trailing attrs block like:
                        // Modifier.AttrClasses("resume-button") { attr("type", "button"); onClick { ... } }
                        fun Modifier.AttrClasses(classString: String, block: AttrsScope<*>.() -> Unit): AttrsScope<*>.() -> Unit = {
                            classes(*classString.split(Regex("\\s+")).toTypedArray())
                            block()
                        }

                        fun Modifier.ModClasses(classString: String): Modifier {
                            return this.classNames(classString.split(Regex("\\s+")))
                        }
                        
                        resources -> styles.css
                        .navbar {
                            width: 100%;
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            align-items: center;
                            padding: 1rem 0rem;
                        }
                        
                        //Access
                        Modifier.AttrClasses("navbar")
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    var title by remember { mutableStateOf("") }
                    var isExpanded by remember { mutableStateOf(false) }
                    
                    Input(
                        type = InputType.Text,
                        attrs = {
                            placeholder("Title")
                            id("title")
                            style {
                                width(100.percent)
                                border(0.px)
                                backgroundColor(Color.transparent)
                                fontSize(18.px)
                                fontWeight(FontWeight.Medium.toString())
                                padding(8.px)
                                outline("none")
                            }
                            value(title)
                            onInput { event -> title = event.value }
                        },
                    )
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    var content by remember { mutableStateOf("") }
                    var isExpanded by remember { mutableStateOf(false) }
    
                    TextArea(
                        attrs = {
                            placeholder(if (isExpanded) "Take a note..." else "Click to add a note...")
                            id("content")
                            style {
                                width(100.percent)
                                border(0.px)
                                backgroundColor(Color.transparent)
                                fontSize(16.px)
                                height(if (isExpanded) 150.px else 50.px)
                                padding(8.px)
                                outline("none")
                                property("resize", "none")
                            }
                            value(content)
                            onInput { event -> content = event.target.value }
                        },
                    )
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    @Composable
                    fun LoadingSpinner() = Img("/loader.gif")
                    
                    @Composable
                    fun TodoForm(
                        placeholder: String,
                        loading: Boolean,
                        submitTodo: (String) -> Unit,
                    ) {
                        if (loading) {
                            TodoCard {
                                LoadingSpinner()
                            }
                        } else {
                            var todo by remember { mutableStateOf("") }
                            Form(
                                attrs =
                                    listOf(TodoStyle, TodoContainerStyle).toAttrs {
                                        onSubmit { evt ->
                                            evt.preventDefault()
                                            submitTodo(todo)
                                        }
                                    },
                            ) {
                                Input(
                                    InputType.Text,
                                    attrs =
                                        listOf(TodoStyle, TodoTextStyle, TodoInputStyle)
                                            .toAttrs {
                                                placeholder(placeholder)
                                                name("todos")
                                                onChange { todo = it.value }
                                            },
                                )
                            }
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    @Composable
                    fun TodoCard(
                        onClick: (() -> Unit)? = null,
                        content: @Composable () -> Unit,
                    ) {
                        val styles = mutableListOf(TodoStyle, TodoContainerStyle, TodoTextStyle)
                        if (onClick != null) {
                            styles.add(TodoClickableStyle)
                        }

                        // Use "A" so the item supports a11y (you can tab on it and press enter to click it)
                        A(
                            href = "#",
                            attrs =
                                styles.toAttrs {
                                    tabIndex(0) // Make this item tabbable

                                    onClick { evt ->
                                        evt.preventDefault() // We are using "A" for its a11y side effects but don't want its actual behavior
                                        onClick?.invoke()
                                    }
                                },
                        ) {
                            content()
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    @Suppress("FunctionName") // Ape composable naming convention
                    class BulletsScope {
                        private val children = mutableListOf<@Composable () -> Unit>()

                        @Composable
                        internal fun render() {
                            children.forEach { it() }
                        }

                        fun Item(value: String, modifier: Modifier = Modifier) {
                            children.add { Li(modifier.toAttrs()) { Text(value) } }
                        }

                        fun Item(value: String, modifier: Modifier = Modifier, content: BulletsScope.() -> Unit) {
                            val subscope = BulletsScope().apply(content)
                            children.add {
                                Li(modifier.toAttrs()) {
                                    Text(value)
                                    Ul { subscope.render() }
                                }
                            }
                        }
                    }

                    @Composable
                    fun Bullets(content: BulletsScope.() -> Unit) {
                        val scope = BulletsScope().apply(content)
                        Ul { scope.render() }
                    }
                    
                    Bullets {
                        Item("5*", Modifier.step(auto = true))
                        Item("6*", Modifier.step(auto = true))
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    Link(
                        "https://multiplatformdeveloper.netlify.app",
                        "Kotlin Multiplatform Developer",
                    )
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //Responsive 
                    Column(
                        modifier = Modifier.fillMaxWidth(percent = 70.percent).padding(left = 1.cssRem)
                    ) { }
                    
                    val breakpoint = rememberBreakpoint()
                    when (breakpoint) {
                            Breakpoint.SM -> 
                            Breakpoint.MD -> 
                            else ->
                               
                        }
                    """.trimIndent()
            )

            //https://github.com/tozydev/lucid-abyss.git
            KotlinCode(
                code = """
                        //Scrolling Manage 1
                        val scrollingState = rememberScrollingState()
                        
                        val shouldHideHeaderAndNav = scrollingState.isScrollingDown && scrollingState.currentScrollY > 50 //Header NavigationBar
                        val shouldHideBackToTop = !scrollingState.isScrollingDown || scrollingState.currentScrollY <= 300 //Up-Down 
                        
                         //Scrolling Manage 2
                         fun backToTopButton() {
                            val breakpoint = rememberBreakpoint()
                            var scroll: Double? by remember { mutableStateOf(null) }

                            LaunchedEffect(Unit) {
                                window.addEventListener(type = "scroll", callback = {
                                    scroll = document.documentElement?.scrollTop
                                })
                            }
                         }
                         
                         .visibility(
                            if (scroll != null && scroll!! > 400.0) {
                                Visibility.Visible
                            } else {
                                Visibility.Hidden
                            }
                         )
                    """.trimIndent()
            )

            //https://github.com/tozydev/lucid-abyss.git
            KotlinCode(
                code = """
                    //Pagination Logic
                    
                    @Composable
                    fun Pagination(
                        pages: List<Int>,
                        currentPage: Int,
                        hrefForPage: (Int) -> String,
                        modifier: Modifier = Modifier,
                    ) {
                        if (pages.isEmpty()) return

                        val currentIndex = pages.indexOf(currentPage).takeIf { it >= 0 } ?: return
                        val prevPage = pages.getOrNull(currentIndex - 1)
                        val nextPage = pages.getOrNull(currentIndex + 1)
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //Get Current DateTime
                    
                    fun getFormattedTime(timeZone: String): String {
                        val options = js("{ timeZone: timeZone, hour: '2-digit', minute: '2-digit', hour12: true }")
                        return Date().toLocaleTimeString("en-US", options)
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //ReactPlayer
                   
                    @file:JsModule("react-player")
                    @file:JsNonModule

                    import react.ComponentClass
                    import react.Props
                    @JsName("default")
                    external val ReactPlayer: ComponentClass<ReactPlayerProps>
                    external interface ReactPlayerProps : Props {
                        var url: String
                        var controls: Boolean
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    SegmentedButtons(
                        text = "Select New Status:",
                        options = listOf("Available", "Rented", "Maintenance"),
                        selectedOption = status,
                        onOptionSelected = { status = it }
                    )
                    
                    @Composable
                    fun <T> SegmentedButtons(
                        text: String,
                        options: List<T>,
                        selectedOption: T,
                        onOptionSelected: (T) -> Unit,
                        modifier: Modifier = Modifier,
                        optionLabel: (T) -> String = { it.toString() }
                    ) {
                        Column(
                            modifier = modifier,
                            horizontalAlignment = Alignment.CenterHorizontally
                        ) {
                            Span(attrs = Modifier.color(Color.white).margin(bottom = 10.px).toAttrs()) {
                                Text(text)
                            }
                            Row(horizontalArrangement = Arrangement.spacedBy(10.px)) {
                                options.forEach { option ->
                                    ToggleButton(
                                        text = optionLabel(option),
                                        isSelected = option == selectedOption,
                                        onClick = { onOptionSelected(option) }
                                    )
                                }
                            }
                        }
                    }
                    
                    @Composable
                    fun ToggleButton(text: String, isSelected: Boolean, onClick: () -> Unit) {
                        Button(
                            attrs = Modifier
                                .padding(leftRight = 15.px, topBottom = 8.px)
                                .borderRadius(8.px)
                                .backgroundColor(if (isSelected) rgb(34, 197, 94) else rgba(255,255,255,0.1))
                                .color(Color.white)
                                .cursor(Cursor.Pointer)
                                .styleModifier { property("border", "none") }
                                .toAttrs { onClick { onClick() } }
                        ) {
                            Text(text)
                        }
                    }
                    """.trimIndent()
            )
        }
    }
}

//https://github.com/OmyDaGreat/MalefiKeep.git (List - Add, Delete)
//https://github.com/shaka-it/kmp-multimodule-sample (koin, api call)
//https://github.com/chandbaba284/KobWebApplication
//https://github.com/salomirc/kobwebemptyproject (API calling Best)
//https://github.com/mopeters8/MoPortfolioKobweb.git (Contact Form Value Get)
//https://github.com/tozydev/lucid-abyss.git (tailwind css)
//https://github.com/nikmasi/bike-rental-system.git
//https://github.com/sorenkai-dev/web.git (koin)
//https://github.com/mopeters8/MoPortfolioKobweb.git
//https://github.com/ishanmitra216/Dev-Connect (Good)
//https://github.com/guilhermeber/loja-kobweb.git (Compose Wasm Code Open)
//https://github.com/muhammadnoman11/kobweb-photocraft.git (Image Filter JS call)
//https://github.com/imnithish/able-hands-website
//https://github.com/Haartag/llinsoft-website
//https://github.com/kolesnikov-denys-dev/kolesnikov-denys-dev.github.io (Category Create)
//https://github.com/felix-leyva/SimpleViewModelExample.git (combine 3 category selection)
//https://github.com/Dev-Aditya-More/PokeVerse.git (GroupBy Good, Filter option list top to bottom animation)
//https://github.com/AbhranilNXT/PortfolioKMP
//https://github.com/roywasker/Portfolio
//https://github.com/laetuz/neotica-kobweb.git (Pagination, Music, Upload and Download)
//https://github.com/Hey-Deepak/heydeepak.dev.git (NavigationBar Underline Animation, Code Format good)

//BEST
//https://github.com/abhishek-0203/Kobweb_Portfolio.git
//https://github.com/abhishek-0203/Kobweb_Portfolio.git
//https://mohamedelgohary.dev (github https://github.com/MohamedElgohary88/My-Portfolio, Chat UI)
//https://github.com/OmyDaGreat/KanMan.git (API Calling)
//https://github.com/Garfend/garfend.github.io
//https://github.com/OmyDaGreat/GuptaRealty.git
//https://github.com/yassenRamadan1/yassenRamadan1.github.io.git